import React, { PropsWithChildren, useMemo } from 'react';

import { useGetAppConfig } from '@/api/requests/useGetAppConfig.util.ts';
import { FullPageSpinner } from '@/components/ui/fullPageSpinner/FullPageSpinner.comp.tsx';
import {
  AppConfigContext,
  AppConfigContextValue,
  AppConfigDefaultValues,
} from '@/contexts/appConfig/AppConfig.context.ts';

export const AppConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { appConfig, isErrorGettingAppConfig, isPendingAppConfig } = useGetAppConfig();

  const context = useMemo((): AppConfigContextValue => {
    if (!appConfig) {
      return AppConfigDefaultValues;
    }

    return {
      config: appConfig,
      dataReady: true,
      isCommissionEnabled: appConfig.commissionEnabled,
      isEmailEnabled: appConfig.emailEnabled,
      isEmergencyContactsEnabled: appConfig.emergencyContactsEnabled,
    };
  }, [appConfig]);

  if (isPendingAppConfig) {
    return <FullPageSpinner />;
  }

  if (isErrorGettingAppConfig || !appConfig) {
    throw new Error('Failed to load application config');
  }

  return <AppConfigContext.Provider value={context}>{children}</AppConfigContext.Provider>;
};
